import { LookupProperty } from 'runtime/data/lookupproperty';

export class LookupItem {
    constructor(
        public keyValue: string,
        public displayValue: string,
        public properties: LookupProperty[],
        public parentKeyValue: string,
        public active: boolean,
    ) { }
}